import { api } from "@/api";
import { DocumentoElectronicoDetalles } from "@/shared/types/documento-electronico";

export async function getDEByCDC(cdc: string): Promise<DocumentoElectronicoDetalles> {
  const response = await api.get<DocumentoElectronicoDetalles>(`/de/cdc/${cdc}`);
  return response.data;
}
